import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-yellow-50 flex justify-center flex-col items-center text-justify">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-3xl w-full">
        <h1 className="text-4xl font-bold text-center text-brown-800 mb-6">
          Privacy Policy for ANIL ENGINEER.
        </h1>

        <p className="text-lg text-gray-700 mb-6">
          At Anil Enginer, we are committed to protecting your
          privacy. This privacy policy explains how we collect, use, and
          safeguard your personal information when you visit our website.
        </p>

        <h2 className="text-xl font-semibold text-yellow-800 mb-4">
          1. Information We Collect
        </h2>
        <p className="text-lg text-gray-700 mb-4">
          When you visit our website, we may collect the following types of
          information:
          <ul className="list-disc list-inside text-gray-600">
            <li>
              <strong>Personal Information:</strong> This may include your name,
              email address, phone number, or any other personal data you
              provide when filling out forms or contacting us.
            </li>
            <li>
              <strong>Non-personal Information:</strong> This includes
              information about your device, browser, IP address, and usage
              patterns, which helps us improve our website's functionality.
            </li>
          </ul>
        </p>

        <h2 className="text-xl font-semibold text-yellow-800 mb-4">
          2. How We Use Your Information
        </h2>
        <p className="text-lg text-gray-700 mb-4">
          We use the information we collect to:
          <ul className="list-disc list-inside text-gray-600">
            <li>Provide information about our products and services.</li>
            <li>Respond to your inquiries or requests.</li>
            <li>Improve the user experience on our website.</li>
            <li>Comply with legal obligations.</li>
          </ul>
        </p>

        <h2 className="text-xl font-semibold text-yellow-800 mb-4">
          3. Cookies
        </h2>
        <p className="text-lg text-gray-700 mb-4">
          Our website uses cookies to enhance your experience. Cookies are small
          files that are stored on your device and help us analyze web traffic
          or remember your preferences. You can choose to accept or decline
          cookies, but declining may affect certain features of the website.
        </p>

        <h2 className="text-xl font-semibold text-yellow-800 mb-4">
          4. Data Security
        </h2>
        <p className="text-lg text-gray-700 mb-4">
          We take reasonable precautions to protect your personal information.
          However, please note that no method of data transmission over the
          internet is 100% secure. We strive to use commercially acceptable
          means to protect your personal data.
        </p>

        <h2 className="text-xl font-semibold text-yellow-800 mb-4">
          5. Third-Party Links
        </h2>
        <p className="text-lg text-gray-700 mb-4">
          Our website may contain links to other websites. These third-party
          sites have their own privacy policies, and we are not responsible for
          their content or practices. We recommend reviewing the privacy
          policies of any external sites you visit.
        </p>

        <h2 className="text-xl font-semibold text-yellow-800 mb-4">
          6. Sharing Your Information
        </h2>
        <p className="text-lg text-gray-700 mb-4">
          We do not sell, trade, or rent your personal information to third
          parties. However, we may share your information with trusted service
          providers who assist us in operating our website and conducting our
          business, as long as they agree to keep this information confidential.
        </p>

        <h2 className="text-xl font-semibold text-yellow-800 mb-4">
          7. Your Rights
        </h2>
        <p className="text-lg text-gray-700 mb-4">
          You have the right to access, update, or delete your personal
          information that we hold. If you wish to exercise any of these rights,
          please contact us using the details below.
        </p>

        <h2 className="text-xl font-semibold text-yellow-800 mb-4">
          8. Changes to This Privacy Policy
        </h2>
        <p className="text-lg text-gray-700 mb-4">
          We reserve the right to update this privacy policy at any time. Any
          changes will be reflected on this page, and the "Last Updated" date
          will be revised accordingly. We encourage you to review this policy
          periodically.
        </p>
        <h2 className="text-xl font-semibold text-yellow-800 mb-4">
          9. Contact Us
        </h2>
        <p className="text-lg text-gray-700 mb-4">
          If you have any questions or concerns about our privacy policy, please
          contact us at:
        </p>
        <p className="text-lg text-gray-700 mt-2">
          <a href="tel:9425106083" className="font-bold">
            +91 9425 106 083
          </a>
        </p>
        <p className="text-lg text-gray-700 mt-2">
          <a href="mailto:anilengineer67@gmail.com" className="font-bold">
            anilengineer67@gmail.com
          </a>
        </p>
        <p className="text-lg text-gray-700 mt-2">
          <a
            href="https://maps.app.goo.gl/BLuXPBWtam6wP6g99"
            className="font-bold"
          >
            Office: No. 1, 1st Floor, Jaroli Trade Center , Madhya Pradesh, India
          </a>
        </p>
      </div>
      <div className="py-5 text-3xl font-bold text-green-800">
        **ANIL ENGINEER **
      </div>
    </div>
  );
};

export default PrivacyPolicy;
